var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('router-link',{attrs:{"to":{ name: _vm.routeName, params: { id: _vm.resourceId }}}},[_c('b',[_vm._t("default")],2)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }